import { useAllInvestmentProjectsDatesQuery } from "@/api/graphql"

// This specifically calls Investment projects
export function useInvestmentsProjectsFirstDate() {
	const query = useAllInvestmentProjectsDatesQuery()

	// Customize the data to fetch single project
	return {
		data: {
			...query.data,
			project:
				query.data?.me?.investment_projects?.results?.reduce(
					(minStartDateProject, currentProject) => {
						const currentDate = new Date(currentProject?.start)
						const minDate = new Date(minStartDateProject?.start)

						return currentDate < minDate
							? currentProject
							: minStartDateProject
					},
					query.data.me.investment_projects.results[0],
				) ?? null,
		},
	}
}
